export const socialPosts = {
  preview: {
    connectionLevel: '3.º+',
    timeAgo: 'Ahora',
    seeMore: 'ver más',
    seeLess: 'ver menos',
    commentCount: '{{value}} comentarios',
    repostCount: '{{value}} republicaciones',
    author: 'Autor',
    genericPosition: 'Tu titular en LinkedIn',
    imageAlt: 'Adjunto {{index}} de {{total}}',
    companyMentionTitle: 'Empresa: {{name}}',
    clickToEdit: 'Hacé clic para editar',
    editorPlaceholder: '¿De qué querés hablar?',
    commentPlaceholder: 'Escribí el primer comentario…',
    dismissLink: 'Quitar la vista previa del enlace',
    editMode: 'Modo edición',
    previewMode: 'Modo vista previa',
    desktopView: 'Vista de escritorio',
    mobileView: 'Vista móvil',
    characterCount: '{{current}}/{{limit}} caracteres',
    characterLimitReached: 'Llegaste al límite de caracteres',
    characterLimitWarning: 'Te quedan {{remaining}} caracteres',

    actions: {
      like: 'Recomendar',
      comment: 'Comentar',
      share: 'Compartir',
      send: 'Enviar',
    },

    commentActions: {
      like: 'Recomendar',
      reply: 'Responder',
    },
  },

  mentions: {
    companyBadge: 'Empresa',
    searching: 'Buscando en LinkedIn…',
  },

  formatting: {
    groupLabel: 'Formato de texto',
    bold: 'Negrita',
    italic: 'Cursiva',
    underline: 'Subrayado',
    strikethrough: 'Tachado',
    emoji: 'Emoji',
    searchEmoji: 'Buscar emoji',
  },

  composer: {
    authorFallback: 'Tu perfil de LinkedIn',

    actions: {
      publish: 'Publicar en LinkedIn',
      saveDraft: 'Guardar borrador',
      registerManually: '¿Ya lo publicaste por fuera? Registralo a mano',
      retryLoad: 'Reintentar',
    },

    account: {
      notConnected:
        'Conectá tu cuenta de LinkedIn para publicar desde acá. Mientras tanto podés seguir escribiendo y guardar el borrador.',
      needsRepair:
        'Tu cuenta de LinkedIn no está disponible ahora, así que publicar queda deshabilitado. Podés seguir escribiendo y guardar el borrador.',
      goToIntegrations: 'Ir a integraciones',
    },

    attachments: {
      syncing: 'Guardando las imágenes…',
      syncFailed: 'No se pudieron guardar las imágenes. Volvemos a cargar lo que está guardado.',
      unreadable: 'Estos adjuntos no se pudieron cargar del almacenamiento: {{files}}',
    },

    mentions: {
      searchFailed: 'No se pudo consultar LinkedIn para buscar menciones. Seguí escribiendo y probá de nuevo en un momento.',
    },

    published: {
      title: 'Esta pieza ya está publicada en LinkedIn.',
      viewOnLinkedIn: 'Ver la publicación',
      firstCommentFailed: 'El post salió, pero su primer comentario no: {{reason}}',
    },

    lastFailure: {
      title: 'El último intento de publicar falló (intento {{attempts}}):',
      caution:
        'Si fue un timeout, el post puede haber salido igual — revisá en LinkedIn antes de reintentar.',
    },

    stuck: {
      title: 'Esta publicación quedó a mitad de camino.',
      body:
        'Nunca llegó la respuesta de LinkedIn, así que este borrador ya no se puede volver a enviar desde acá. Verificá contra LinkedIn para resolverlo automáticamente — o revisá a mano y registralo.',
      verify: 'Verificar contra LinkedIn',
      verifying: 'Consultando LinkedIn…',
      verifyFailed: 'No se pudo correr la verificación contra LinkedIn.',
      resolvedPublished: 'El post está en LinkedIn — quedó registrado como publicado.',
      resolvedFailed: 'Verificado: el post nunca salió. Podés editarlo y reintentar.',
      inconclusiveTitle: 'La verificación no pudo decidir.',
      inconclusiveReasons: {
        mentions_rewrite_text:
          'El post lleva menciones, y LinkedIn las reescribe — el texto que devuelve nunca puede coincidir con el nuestro, así que no encontrarlo no prueba nada. Revisá el perfil y resolvelo a mano.',
        unparseable_created_at:
          'Se encontró un post con este texto, pero su fecha no se pudo leer, así que no sabemos si es este. Revisá el perfil y resolvelo a mano.',
        page_window_not_covered:
          'LinkedIn devolvió demasiados posts recientes para llegar hasta el momento del envío — puede existir más allá de lo que pudimos leer. Revisá el perfil y resolvelo a mano.',
        unknown:
          'LinkedIn no pudo confirmar el post como presente ni como ausente. Revisá el perfil y resolvelo a mano.',
      },
    },

    schedule: {
      action: 'Programar',
      timeLabel: 'Hora',
      timezoneNote: 'Horarios en {{timezone}}',
      confirm: 'Programar post',
      confirmReschedule: 'Reprogramar',
      banner: {
        title: 'Programado para el {{datetime}}',
        editLocked:
          'El texto queda bloqueado mientras el post está programado — cancelá la programación para editarlo.',
        reschedule: 'Reprogramar',
        cancel: 'Cancelar programación',
        cancelTitle: '¿Cancelar esta programación?',
        cancelBody: 'El post vuelve a ser un borrador y no se va a publicar automáticamente.',
        cancelConfirm: 'Cancelar programación',
        cancelKeep: 'Dejarlo programado',
      },
      toast: {
        scheduled: 'Post programado',
        cancelled: 'Programación cancelada',
      },
      errors: {
        tooSoon: 'Elegí un horario al menos {{minutes}} minutos en el futuro.',
        scheduleFailed: 'No se pudo programar el post.',
        cancelFailed: 'No se pudo cancelar la programación.',
      },
    },

    publishError: {
      genericTitle: 'El post no se publicó.',

      unconfirmedTitle: 'No pudimos confirmar si el post salió.',
      unconfirmedBody:
        'LinkedIn nunca respondió, así que el post puede estar publicado. Revisalo antes de reintentar — publicarlo dos veces no se deshace desde acá.',
      checkOnLinkedIn: 'Revisar en LinkedIn',
      unconfirmedAcknowledge: 'Ya revisé, no está',
      unconfirmedAcknowledged: 'Publicar quedó habilitado de nuevo.',

      notRecordedTitle: 'El post SÍ se publicó, pero no lo pudimos registrar.',
      notRecordedBody:
        'Guardá este link: es la única copia que tenemos. Registrá la publicación a mano para que la pieza quede cerrada.',
      notRecordedAcknowledge: 'Ya guardé el link',
      copyUrl: 'Copiar el link',
      urlCopied: 'Link copiado',
      registerManually: 'Registrarlo a mano',
    },

    unsaved: {
      indicator: 'Cambios sin guardar',
      title: 'Tenés cambios sin guardar',
      body:
        'Lo que escribiste todavía no está en el borrador. Si salís de la pieza ahora, se pierde el texto.',
      stay: 'Seguir editando',
      leave: 'Salir sin guardar',
      saveAndLeave: 'Guardar y salir',
      saving: 'Guardando…',
    },

    versions: {
      action: 'Historial de edición',
      title: 'Historial de edición',
      description:
        'Cada guardado que cambió el texto de este post, más cada restauración — lo más nuevo primero.',
      empty: 'Todavía no hay versiones. Aparecen cuando un guardado cambia el texto.',
      version: 'v{{version}}',
      back: 'Volver a la lista',
      firstComment: 'Primer comentario',
      trigger: {
        manual_edit: 'Edición manual',
        restore: 'Restauración',
      },
      time: {
        justNow: 'Recién',
        minutesAgo: 'hace {{minutes}}m',
        hoursAgo: 'hace {{hours}}h',
        daysAgo: 'hace {{days}}d',
      },
      restore: {
        action: 'Restaurar esta versión',
        title: '¿Restaurar v{{version}}?',
        body:
          'El texto del editor se reemplaza con esta versión. El texto guardado actual queda como una versión nueva primero, así que nada guardado se pierde.',
        dirtyWarning:
          'Tenés cambios sin guardar en el editor — restaurar también los reemplaza, y no se pueden recuperar.',
        confirm: 'Restaurar',
        cancel: 'Cancelar',
        blocked:
          'Este post ya no se puede editar, así que no se puede restaurar. Cancelá la programación primero, o dejá un post publicado tal como salió.',
      },
      retry: 'Reintentar',
      toast: {
        restored: 'Versión restaurada',
      },
      errors: {
        loadFailed: 'No se pudieron cargar las versiones.',
        detailLoadFailed: 'No se pudo cargar esta versión.',
        restoreFailed: 'No se pudo restaurar la versión.',
      },
    },

    toast: {
      draftSaved: 'Borrador guardado',
      published: 'Publicado en LinkedIn',
      publishedWithoutComment: 'Se publicó, pero el primer comentario no salió',
    },

    errors: {
      loadFailed: 'No se pudo cargar el borrador.',
      saveFailed: 'No se pudo guardar el borrador.',
    },
  },

  uploader: {
    dropLabel: 'Arrastrá las imágenes acá, o hacé clic para elegirlas',
    dropHint: 'Hasta {{maxFiles}} imágenes, {{maxSize}} cada una',
    dragActive: 'Soltá las imágenes acá',
    compactLabel: 'Agregar imágenes',
    checking: 'Revisando las imágenes…',
    limitReached: 'Una publicación admite {{maxFiles}} imágenes como máximo.',
    attachedCount: '{{value}} adjuntas',
    dragToReorder: '(arrastrá para reordenar)',
    dragToReorderHandle: 'Arrastrá para reordenar {{fileName}}',
    removeFile: 'Quitar archivo',

    kind: {
      image: 'imágenes',
      video: 'un video',
      pdf: 'un PDF',
    },

    errors: {
      mixedTypes: 'Una publicación solo admite {{kind}}, así que el resto quedó afuera.',
      tooMany: 'Una publicación admite {{max}} {{kind}} como máximo — las de más quedaron afuera.',
      unsupportedType: '{{fileName}} no es un tipo de archivo admitido. Usá JPG, PNG o GIF.',
      fileTooLarge: '{{fileName}} pesa más de {{maxSize}}.',
      imageDimensions: '{{fileName}} mide más de {{maxDimension}} px de ancho o de alto.',
      imageResolution: '{{fileName}} supera los {{maxMegapixels}} megapíxeles.',
      gifPixels: '{{fileName}} es un GIF de más de {{maxGifPixels}} píxeles.',
    },
  },
}
